<div class="prt">
  <div class="prt-tools">
    <div class="seg" role="group" aria-label="filter policies">
      <button
        *ngFor="let f of filters"
        type="button"
        [attr.aria-pressed]="filter() === f"
        (click)="setFilter(f)"
      >
        {{ f === 'pending' ? 'Pending' : f === 'approved' ? 'Approved' : 'All' }}
        <span class="seg-n">{{ f === 'pending' ? pendingCount() : f === 'approved' ? approvedCount() : totalCount() }}</span>
      </button>
    </div>

    <input
      class="prt-search"
      type="text"
      [ngModel]="query()"
      (ngModelChange)="query.set($event)"
      placeholder="Search statement or policy type…"
      aria-label="search policies"
    />

    <span class="prt-count">{{ filtered().length }} / {{ totalCount() }}</span>
  </div>

  <div class="prt-list" *ngIf="filtered().length; else empty">
    <div class="prow" *ngFor="let p of filtered(); trackBy: trackById" [class.approved]="p.review">
      <div class="prow-main">
        <div class="prow-text">
          <div class="statement">{{ p.statement }}</div>
          <div class="prow-meta">
            <span
              class="chip"
              [style.background]="typeStyle(p.policy_type).bg"
              [style.color]="typeStyle(p.policy_type).fg"
            >{{ p.policy_type }}</span>

            <button
              type="button"
              class="ev-toggle"
              (click)="toggleEvidence(p.policy_id)"
              [attr.aria-expanded]="isExpanded(p.policy_id)"
            >
              {{ isExpanded(p.policy_id) ? 'Hide evidence' : 'Show evidence' }}
            </button>
          </div>
        </div>

        <div class="prow-actions">
          <span class="status-dot" [class.on]="p.review" [class.off]="!p.review"></span>
          <button
            type="button"
            class="review-btn"
            [class.reject]="p.review"
            [class.approve]="!p.review"
            [disabled]="isPending(p.policy_id)"
            (click)="onToggleReview(p)"
          >
            <span *ngIf="isPending(p.policy_id)" class="spinner" aria-hidden="true"></span>
            <span>{{ p.review ? 'Reject' : 'Approve' }}</span>
          </button>
        </div>
      </div>

      <div class="evidence" *ngIf="isExpanded(p.policy_id)">
        <span class="ev-label">Source evidence</span>
        <p class="ev-text">{{ p.evidence_text }}</p>
      </div>
    </div>
  </div>

  <ng-template #empty>
    <div class="prt-empty">No policies match this filter.</div>
  </ng-template>
</div>
